import { ComponentStyleConfig } from '@chakra-ui/react'

export const Radio: ComponentStyleConfig = {
  baseStyle: {
    control: {
      _checked: {
        _disabled: {
          bg: 'white',
          borderColor: 'neutral.20',
          borderWidth: '4px',
          color: 'white',
          cursor: 'not-allowed',
        },
      },
      _disabled: {
        bg: 'white',
        borderColor: 'neutral.20',
        cursor: 'not-allowed',
      },
      borderColor: 'neutral.40',
      borderWidth: '1px',
      cursor: 'pointer',
    },
    label: {
      _disabled: {
        color: 'neutral.50',
        cursor: 'not-allowed',
      },
      cursor: 'pointer',
    },
  },
  defaultProps: {
    colorScheme: 'brand',
    size: 'md',
  },
  variants: {},
}

export const RadioGroup: ComponentStyleConfig = {
  baseStyle: {},
  defaultProps: {
    colorScheme: 'deepPurple',
    size: 'md',
  },
  variants: {},
}
